export default {
  SET_ACTIVE_TAB: 'SET_ACTIVE_TAB',
  SET_BUTTONS_HEADER_HEIGHT: 'SET_BUTTONS_HEADER_HEIGHT',
  RESET_BUTTONS_HEADER: 'RESET_BUTTONS_HEADER',
  CHANGE_DOSSIER_SUBTYPE: 'CHANGE_DOSSIER_SUBTYPE',
  SELECT_VO_COMPANY: 'SELECT_VO_COMPANY',
  SALE_TO_VO_COMPANY: 'SALE_TO_VO_COMPANY',
  APPROVE_MARGIN: 'APPROVE_MARGIN'
}
